<div fxLayout="row wrap">


    <div fxLayout="column" fxFlex="48" fxFlex.lt-md="100" class="form-block">
        <h3>{{'admin-center.header.employeeData' | translate}}</h3>
        <span *ngIf="!employee">{{'validations.errorWhenLoadingData' | translate}}</span>
        <div>
            <form *ngIf="employee" [formGroup]="editDataForm">
                <div fxLayout="column">
                    <app-employee-form [form]="editDataForm"></app-employee-form>
                </div>

                <div>&nbsp;</div>
                <div *ngIf="employee.employeeCompany" fxLayout="column">
                    <strong><u>{{'admin-center.employee.employeeAssociatedWithEmployeeCompany' | translate}}</u></strong>
                    <div fxLayout="row">
                        {{'admin-center.entity.shortName' | translate}}: <strong>{{employee.employeeCompany.entity.shortName}}</strong>
                    </div>
                    <div fxLayout="row">
                        {{'admin-center.entity.fullName' | translate}}: <strong>{{employee.employeeCompany.entity.fullName}}</strong>
                    </div>
                    <div fxLayout="row">
                        {{'admin-center.entity.address' | translate}}: 
                        <strong>{{employee.employeeCompany.entity.streetAndNumber}}, {{employee.employeeCompany.entity.zipCode}} {{employee.employeeCompany.entity.city}}, 
                            {{employee.employeeCompany.entity.voivodeshipId | staticDictionaryCaption:'voivodeship' |async}} </strong>
                    </div>
                    <div fxLayout="row">
                        {{'admin-center.entity.fiscalNumber' | translate}}: <strong>{{employee.employeeCompany.entity.fiscalIdentifier}}</strong>
                    </div>
                    <div fxLayout="row">
                        {{'admin-center.entity.iban' | translate}}: <strong>{{employee.employeeCompany.entity.iban}}</strong>
                    </div>
                    <div fxLayout="row">
                        {{'admin-center.entity.defaultPaymentMethod' | translate}}: 
                        <strong>{{employee.employeeCompany.entity.defaultPaymentMethodId | staticDictionaryCaption:'paymentMethod' |async}}</strong>
                    </div>
                    <div fxLayout="row">
                        {{'admin-center.entity.paymentDueDays' | translate}}: 
                        <strong>{{employee.employeeCompany.entity.defaultPaymentDueDays}}</strong>
                    </div>
                    <div fxLayout="row">
                        {{'admin-center.entity.email' | translate}}: 
                        <strong>{{employee.employeeCompany.entity.contactEmail}}</strong>
                    </div>

                    <div fxLayout="row">
                        {{'admin-center.entity.phoneNumber' | translate}}: 
                        <strong>{{employee.employeeCompany.entity.contactPhoneNumber}}</strong>
                    </div>
                </div>

                <div *ngIf="!employee.employeeCompany">
                    <b><u>{{'admin-center.employee.employeeIsNotAssociatedWithEmployeeCompanyData' | translate}}</u></b>
                </div>

                <div fxLayoutAlign="end end">
                    <button type="button" kendoButton (click)="update()" [primary]="true" submit>
                        {{'global.update' | translate}}</button>
                </div>
            </form>
        </div>
    </div>


    <div *ngIf="employee" fxLayout="column" fxFlex="48" fxFlex.lt-md="100" class="form-block" fxLayoutGap="25">

        <h3>{{'admin-center.header.employeeReconcileInfo' | translate}}</h3>

        <div fxLayout="row">

            <div fxLayout="column" fxFlex="48" fxFlex.lt-md="100">
                <strong>{{'admin-center.employee.provisionForInspection' | translate}}</strong>

                <app-periodical-value-input-ctrl [identifier]="employee.provisionStandardInspection"
                    [caption]="'admin-center.employee.provisionStandardInspection'">
                </app-periodical-value-input-ctrl>

                <app-periodical-value-input-ctrl [identifier]="employee.provisionAdditionalInspection"
                    [caption]="'admin-center.employee.provisionAdditionalInspection'">
                </app-periodical-value-input-ctrl>
            </div>

            <div fxLayout="column" fxFlex="48" fxFlex.lt-md="100">
                <strong>{{'admin-center.employee.provisionForPdrRepair' | translate}}</strong>

                <app-periodical-value-input-ctrl [identifier]="employee.provisionPdrRepairInsuranceCompany"
                    [caption]="'admin-center.employee.provisionPdrRepairInsuranceCompany'">
                </app-periodical-value-input-ctrl>

                <app-periodical-value-input-ctrl [identifier]="employee.provisionPdrRepairPartnerService"
                    [caption]="'admin-center.employee.provisionPdrRepairPartnerService'">
                </app-periodical-value-input-ctrl>

                <app-periodical-value-input-ctrl [identifier]="employee.provisionPdrRepairFleet"
                    [caption]="'admin-center.employee.provisionPdrRepairFleet'">
                </app-periodical-value-input-ctrl>

                <app-periodical-value-input-ctrl [identifier]="employee.provisionPdrRepairPrivate"
                    [caption]="'admin-center.employee.provisionPdrRepairPrivate'">
                </app-periodical-value-input-ctrl>
            </div>
        </div>


        <div fxLayout="row">

            <div fxLayout="column" fxFlex="48" fxFlex.lt-md="100">
                <strong>{{'admin-center.employee.provisionForAssembly' | translate}}</strong>

                <app-periodical-value-input-ctrl [identifier]="employee.provisionAssemblyInsuranceCompany"
                    [caption]="'admin-center.employee.provisionAssemblyInsuranceCompany'">
                </app-periodical-value-input-ctrl>

                <app-periodical-value-input-ctrl [identifier]="employee.provisionAssemblyPartnerService"
                    [caption]="'admin-center.employee.provisionAssemblyPartnerService'">
                </app-periodical-value-input-ctrl>

                <app-periodical-value-input-ctrl [identifier]="employee.provisionAssemblyFleet"
                    [caption]="'admin-center.employee.provisionAssemblyFleet'">
                </app-periodical-value-input-ctrl>

                <app-periodical-value-input-ctrl [identifier]="employee.provisionAssemblyPrivate"
                    [caption]="'admin-center.employee.provisionAssemblyPrivate'">
                </app-periodical-value-input-ctrl>

            </div>

            <div fxLayout="column" fxFlex="48" fxFlex.lt-md="100">
                <strong>{{'admin-center.employee.provisionForDisassembly' | translate}}</strong>

                <app-periodical-value-input-ctrl [identifier]="employee.provisionDisassemblyInsuranceCompany"
                    [caption]="'admin-center.employee.provisionDisassemblyInsuranceCompany'">
                </app-periodical-value-input-ctrl>

                <app-periodical-value-input-ctrl [identifier]="employee.provisionDisassemblyPartnerService"
                    [caption]="'admin-center.employee.provisionDisassemblyPartnerService'">
                </app-periodical-value-input-ctrl>

                <app-periodical-value-input-ctrl [identifier]="employee.provisionDisassemblyFleet"
                    [caption]="'admin-center.employee.provisionDisassemblyFleet'">
                </app-periodical-value-input-ctrl>

                <app-periodical-value-input-ctrl [identifier]="employee.provisionDisassemblyPrivate"
                    [caption]="'admin-center.employee.provisionDisassemblyPrivate'">
                </app-periodical-value-input-ctrl>

            </div>
        </div>

        <div fxLayout="row">

            <div fxLayout="column" fxFlex="48" fxFlex.lt-md="100">
                <strong>{{'admin-center.employee.provisionForWashing' | translate}}</strong>
                <app-periodical-value-input-ctrl [identifier]="employee.provisionCarWashingBeforeRepair"
                    [caption]="'admin-center.employee.provisionCarWashingBeforeRepair'">
                </app-periodical-value-input-ctrl>

                <app-periodical-value-input-ctrl [identifier]="employee.provisionCarWashingAfterRepair"
                    [caption]="'admin-center.employee.provisionCarWashingAfterRepair'">
                </app-periodical-value-input-ctrl>
            </div>

            <div fxLayout="column" fxFlex="48" fxFlex.lt-md="100">
                <strong>{{'admin-center.employee.provisionForExchanges' | translate}}</strong>
                <app-periodical-value-input-ctrl [identifier]="employee.provisionExchangesInsuranceCompany"
                    [caption]="'admin-center.employee.provisionExchangesInsuranceCompany'">
                </app-periodical-value-input-ctrl>

                <app-periodical-value-input-ctrl [identifier]="employee.provisionExchangesPartnerService"
                    [caption]="'admin-center.employee.provisionExchangesPartnerService'">
                </app-periodical-value-input-ctrl>

                <app-periodical-value-input-ctrl [identifier]="employee.provisionExchangesFleet"
                    [caption]="'admin-center.employee.provisionExchangesFleet'">
                </app-periodical-value-input-ctrl>

                <app-periodical-value-input-ctrl [identifier]="employee.provisionExchangesPrivate"
                    [caption]="'admin-center.employee.provisionExchangesPrivate'">
                </app-periodical-value-input-ctrl>
            </div>

        </div>

    </div>

</div>